export const convertTimeStampDateToDateAndTime = (
  timestampDateTime?: string,
) => {
  const dateObj = timestampDateTime ? new Date(timestampDateTime) : new Date();
  const date = dateObj.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

  const time = dateObj.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
  });

  return { date, time };
};
